import { Icon } from "semantic-ui-react";

import "modules/PendingChecklistsDashboard/components/EditChecklistsButton/EditChecklistsButton.scss";

type EditChecklistsButtonProps = {
  onClick: () => void;
};

export const EditChecklistsButton = ({ onClick }: EditChecklistsButtonProps) => (
  <div className="EditChecklistsButton">
    <button className="edit-checklists-button" onClick={onClick}>
      <Icon className="icon pen to square edit-checklists-button-icon" />
    </button>
  </div>
);
